var map = {
	"./media/BrightnessD.png": "2b12",
	"./media/BrightnessU.png": "605c",
	"./media/Mute.png": "52a7",
	"./media/Playpause.png": "3853",
	"./media/calc.png": "d41b",
	"./media/email.png": "4426",
	"./media/next.png": "91c2",
	"./media/player.png": "1622",
	"./media/previous.png": "ece7",
	"./media/profiles.png": "bd5a",
	"./media/stop.png": "c484",
	"./media/volume+.png": "dcf2",
	"./media/volume-.png": "4b42",
	"./media/web_back.png": "e241",
	"./media/web_bookmarks.png": "fafd",
	"./media/web_home.png": "484e",
	"./media/web_refresh.png": "2c93",
	"./media/web_search.png": "dc24",
	"./media/解锁锁.png": "d9aa",
	"./mouse/back.png": "6872",
	"./mouse/forward.png": "847d",
	"./mouse/leftkey.png": "f346",
	"./mouse/middlekey.png": "7c46",
	"./mouse/rightkey.png": "69d1",
	"./mouse/xj.png": "0bfd",
	"./mouse/xjj.png": "7d38",
	"./mouse/yj.png": "f27b",
	"./mouse/yjj.png": "7555",
	"./system/Lockcomputer.png": "0bc8",
	"./system/Print.png": "a6fe",
	"./system/Selectall.png": "7b55",
	"./system/copy.png": "b0f8",
	"./system/desktop.png": "f441",
	"./system/find.png": "6e5a",
	"./system/mycomputer.png": "a262",
	"./system/newfile.png": "ef9d",
	"./system/paste.png": "85bd",
	"./system/revoke.png": "6f26",
	"./system/run.png": "d723",
	"./system/save.png": "536a",
	"./system/shear.png": "8c4c",
	"./system/togglewindow.png": "b983",
	"./system/windowClose.png": "e28a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "baa3";